import { useState } from "react";
import { X } from "lucide-react";

/** Shown only in preview builds (REACT_APP_PREVIEW=1). */
export default function PreviewBanner() {
  const [open, setOpen] = useState(true);
  if (!open) return null;
  return (
    <div className="sticky top-0 z-[60] flex items-center justify-center gap-3 bg-[#0E2018] px-4 py-1.5 text-xs text-white" data-testid="preview-banner">
      <span className="rounded-full bg-lime px-2 py-0.5 font-semibold text-[#10231B]">Preview</span>
      <span className="truncate">
        Sample data in your browser — nothing is connected to WhatsApp, Instagram or an AI provider. Sign in with any email and password.
      </span>
      <button type="button" onClick={() => setOpen(false)} aria-label="Dismiss" className="ml-2 rounded-full p-0.5 hover:bg-white/15">
        <X className="h-3.5 w-3.5" />
      </button>
    </div>
  );
}
